export const PROJECT_NAME_FORM_KEY = 'project-name';

export const DEFAULT_MC_DENSITY_STR = '45';

export const METER_CORE_DENSITY_OPTIONS = [
  '10',
  '20',
  '25',
  '30',
  DEFAULT_MC_DENSITY_STR,
  '60',
  '75',
  '90',
  '100',
  '125',
  '150',
  '200',
] as const;

export const REGEN_STANDARD = 'Regen Standard';
export const CLIMATE_ACTION_REGISTRY_STANDARD = 'Climate Action Reserve SEP';
export const VERRA_STANDARD = 'Verra VM0042';
export const B_CARBON_STANDARD = 'BCarbon';
export const NO_REGISTRY_STANDARD = 'No Registry Specified';
export const REGISTRY_OPTIONS = [
  REGEN_STANDARD,
  CLIMATE_ACTION_REGISTRY_STANDARD,
  VERRA_STANDARD,
  B_CARBON_STANDARD,
  NO_REGISTRY_STANDARD,
];

export const INITIAL_REGISTRY_OPTIONS = [
  REGEN_STANDARD,
  CLIMATE_ACTION_REGISTRY_STANDARD,
  VERRA_STANDARD,
];

export const METER_CORE = 'Meter Core';
export const SOIL_TEXTURE = 'Soil Texture';

export const CROP_LAND = 'cropland';
export const RANGELAND = 'rangeland';

export const STRATIFY = 'stratify';

export const PROJECT_MAP_COLORS = {
  selectedField: 'magenta',
  otherFields: 'orange',
  selectedCollectionFieldsFill: 'orange',
};

// Temporary
export const LAB_OPTIONS = [
  { value: 'EarthOptics MEM', label: 'EarthOptics Memphis' },
  { value: 'EarthOptics EMY', label: 'EarthOptics Emeryville' },
  { value: 'Regen Ag Lab', label: 'Regen AG' },
  { value: 'Waters AG -GA', label: 'Waters (MS)' },
  { value: 'Waters AG -MS', label: 'Waters (GA)' },
];

// Temporary
export const METER_CORE_SPLITS_OPTIONS = [
  {
    value: '[15, 30, 60]',
    label: '0-15 cm, 15-30 cm, 30-60 cm, 60-100 cm',
  },
  { value: '[30, 60]', label: '0-30 cm, 30-60 cm, 60-100 cm' },
  { value: '[30]', label: '0-30 cm, 30-100 cm' },
];

export const WETLANDS = 'wetlands';
export const HISTOSOL_SOILS = 'histosol_soils';
export const BUILT_INFRASTRUCTURE = 'built_infrastructure';
export const STEEP_SLOPE = 'steep_slope';
export const TREE_SHRUB_COVER = 'tree_shrub_cover';

export const EXCLUSION_LAYER_OPTIONS = [
  WETLANDS,
  HISTOSOL_SOILS,
  BUILT_INFRASTRUCTURE,
  STEEP_SLOPE,
  TREE_SHRUB_COVER,
];

export const LAND_OPTIONS = [
  { value: CROP_LAND, label: 'Cropland' },
  { value: RANGELAND, label: 'Rangeland' },
];

export const METER_STR = '1m';
export const THIRTY_CM_STR = '30cm';
export const DEPTH_OPTIONS = [
  { value: METER_STR, label: '1m' },
  { value: THIRTY_CM_STR, label: '30cm' },
];

export const SOC = 'soc';
export const SIC = 'sic';
// There are two options that act as a boolean on the BE: "SIC". Either has it or doesn't
export const CARBON_ANALYTIC_OPTIONS = [
  { value: SOC, label: 'SOC + BD' },
  { value: SIC, label: 'SOC + SIC + BD' },
];
